import { render, staticRenderFns } from "./clientControl.vue?vue&type=template&id=400148dd&scoped=true&"
import script from "./clientControl.vue?vue&type=script&lang=js&"
export * from "./clientControl.vue?vue&type=script&lang=js&"
import style0 from "./clientControl.vue?vue&type=style&index=0&id=400148dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400148dd",
  null
  
)

component.options.__file = "clientControl.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VFlex,
  VIcon,
  VSelect,
  VTextField,
})
